import useScreenWidth from '@/shared/hooks/useScreenWidth';
import { ToastContainer } from 'react-toastify';
// Вид уведомлений — компонент темы (@toast-view-current, таблица TOAST в
// vite.config): 'Illustrated' у serious и wapclick, 'Icons' у telecom.
import view from '@toast-view-current';

export type { ToastType } from './types';

export const ToastNotification: React.FC = () => {
  const screenWidth = useScreenWidth();
  return <ToastContainer {...view.containerProps(screenWidth)} />;
};
